import React from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from 'react-router-dom';

const Carousel = () => {
  const imgLink = process.env.REACT_APP_IMG_LINK;
  return (
    <>
      <div id='carouselIndicators' className='carousel slide' data-bs-ride='carousel'>
        <div className='carousel-indicators'>
          <button
            type='button'
            data-bs-target='#carouselIndicators'
            data-bs-slide-to='0'
            className='active'
            aria-current='true'
            aria-label='Slide 1'></button>
          <button type='button' data-bs-target='#carouselIndicators' data-bs-slide-to='1' aria-label='Slide 2'></button>
          <button type='button' data-bs-target='#carouselIndicators' data-bs-slide-to='2' aria-label='Slide 3'></button>
        </div>
        <div className='carousel-inner'>
          <div className='carousel-item active' data-bs-interval='5000'>
            <Link to='/category/women'>
              <img src={`${imgLink}/carousel.png`} className='d-block w-100' alt='women slide' />
            </Link>
          </div>
          <div className='carousel-item' data-bs-interval='5000'>
            <Link to='/category/men'>
              <img src={`${imgLink}/carousel-1.png`} className='d-block w-100' alt='men slide' />
            </Link>
          </div>
          <div className='carousel-item' data-bs-interval='5000'>
            <Link to='/category/accessories'>
              <img src={`${imgLink}/carousel-2.png`} className='d-block w-100' alt='accessories slide' />
            </Link>
          </div>
        </div>
        <button
          className='carousel-control-prev'
          type='button'
          data-bs-target='#carouselIndicators'
          data-bs-slide='prev'>
          <span className='carousel-control-prev-icon' aria-hidden='true'></span>
          <span className='visually-hidden'>Previous</span>
        </button>
        <button
          className='carousel-control-next'
          type='button'
          data-bs-target='#carouselIndicators'
          data-bs-slide='next'>
          <span className='carousel-control-next-icon' aria-hidden='true'></span>
          <span className='visually-hidden'>Next</span>
        </button>
      </div>
    </>
  );
};

export default Carousel;
